import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=b0718ad8&scoped=true"
import script from "./fullScreen.vue?vue&type=script&lang=js"
export * from "./fullScreen.vue?vue&type=script&lang=js"
import style0 from "./fullScreen.vue?vue&type=style&index=0&id=b0718ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0718ad8",
  null
  
)

export default component.exports